import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';

// Guard against double-init in test environments that re-import the module
if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: { en: { translation: enTranslation } },
      fallbackLng: 'en',
      lng: 'en',              // pin locale; detector overrides at runtime if language changes
      initImmediate: false,   // synchronous init — required for SSR and prevents test timeouts
      debug: false,
      interpolation: { escapeValue: false },
    })
    .catch((err) => {
      // Non-fatal: app renders translation keys as fallback values if init fails
      console.error('[i18n] initialization failed:', err);
    });
}

export default i18n;
